export const COOKIE_CONSENT_KEY = 'vlm_cookie_consent';
export const COOKIE_CONSENT_VERSION = '1.0';
export const OPEN_COOKIE_SETTINGS_EVENT = 'vlm-open-cookie-settings';

export const DEFAULT_CONSENT = {
  essential: true,
  analytical: false,
  status: null,
  timestamp: null,
  version: COOKIE_CONSENT_VERSION,
};

const isBrowser = () => typeof window !== 'undefined' && typeof localStorage !== 'undefined';

export const getConsent = () => {
  if (!isBrowser()) return null;

  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    // Re-prompt if policy/version changed
    if (parsed.version !== COOKIE_CONSENT_VERSION) return null;

    return {
      essential: true,
      analytical: Boolean(parsed.analytical),
      status: parsed.status || 'custom',
      timestamp: parsed.timestamp || null,
      version: parsed.version || COOKIE_CONSENT_VERSION,
    };
  } catch {
    return null;
  }
};

export const hasConsentDecision = () => Boolean(getConsent()?.status);

export const setConsent = ({ analytical = false, status = 'custom' } = {}) => {
  const payload = {
    essential: true,
    analytical: Boolean(analytical),
    status,
    timestamp: new Date().toISOString(),
    version: COOKIE_CONSENT_VERSION,
  };

  if (isBrowser()) {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload));
  }

  return payload;
};

export const acceptAllCookies = () =>
  setConsent({ analytical: true, status: 'accepted' });

export const rejectAllCookies = () =>
  setConsent({ analytical: false, status: 'rejected' });

export const saveCustomCookies = ({ analytical }) =>
  setConsent({ analytical: Boolean(analytical), status: 'custom' });

export const openCookieSettings = () => {
  if (!isBrowser()) return;
  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
};

export const isAnalyticalAllowed = () => Boolean(getConsent()?.analytical);
